import type {
  corsContactInterface,
  Course,
  CourseContactResponse,
  CoursesResponse,
} from "~/types/Cours";

export const useCoursApi = () => {
  const { $api } = useNuxtApp();

  const getCourses = async (query?: string): Promise<CoursesResponse> => {
    const endpoint = query ? `/courses?${query}` : "/courses";
    return await $api(endpoint);
  };
  const getFilter = async (): Promise<any> => {
    return await $api("/states/compact-stats");
  };
  const courseContact = async (body: corsContactInterface) => {
    const respons = await $api("/course_contacts", {
      method: "POST",
      body,
    });
    return respons;
  };

  const getCourseCategories = async (
    slug: string
  ): Promise<CoursesResponse> => {
    const endpoint = `/course_category/slug/${slug}`;
    return await $api(endpoint);
  };

  const getCourse = async (slug: string): Promise<Course> =>
    await $api(`/courses/${slug}`);

  return {
    getCourses,
    getCourse,
    getCourseCategories,
    courseContact,
    getFilter,
  };
};
